/*
 * editorial-pdp-style.js
 * Powers sections/editorial-pdp-style.liquid (root: [data-ed-pdx]).
 * Standalone: does not depend on or modify editorial.js.
 * Steps: 1 style, 2 jar message (skipped for Bouquet), 3 add-ons.
 * Forked from editorial.js initPdp. Shared features must be updated in both.
 */
(function () {
  'use strict';

  function formatMoney(cents, fmt) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    fmt = fmt || '${{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function withDelim(n, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelim(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelim(cents, 0, '.', ','); break;
      default: value = withDelim(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function init() {
    var root = document.querySelector('[data-ed-pdx]');
    if (!root || root.__pdxBound) return;
    root.__pdxBound = true;

    var fmt = root.getAttribute('data-money-format') || '${{amount}}';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var money = function (c) { return formatMoney(c, fmt); };

    var state = {
      styleId: null, stylePrice: 0, styleLabel: '', noJar: false,
      jarId: null, jarPrice: 0, jarLabel: '', jarPersonalise: false, jarText: '',
      addons: {}, photoAddonId: null
    };

    /* ---------- Gallery ---------- */
    var mainSlider = root.querySelector('[data-ed-pdp-main-slider]');
    var thumbSlider = root.querySelector('[data-ed-pdp-thumbs-slider]');
    var flkty = null;
    var chev = function (d) {
      return '<svg class="ed-pdp__chev" viewBox="0 0 44 44" aria-hidden="true"><path d="' + d +
        '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    };
    function initGallery() {
      if (!mainSlider || !window.Flickity || mainSlider.classList.contains('flickity-enabled')) return;
      var count = mainSlider.querySelectorAll('.ed-pdp__slide').length;
      flkty = new window.Flickity(mainSlider, {
        cellSelector: '.ed-pdp__slide', pageDots: false, prevNextButtons: count > 1,
        wrapAround: true, contain: true, imagesLoaded: true, adaptiveHeight: false
      });
      var pv = mainSlider.querySelector('.flickity-prev-next-button.previous');
      var nx = mainSlider.querySelector('.flickity-prev-next-button.next');
      if (pv) pv.innerHTML = chev('M15 4 L7 12 L15 20');
      if (nx) nx.innerHTML = chev('M9 4 L17 12 L9 20');
      if (thumbSlider) {
        new window.Flickity(thumbSlider, {
          asNavFor: mainSlider, cellSelector: '.ed-pdp__thumb', pageDots: false,
          prevNextButtons: false, contain: true, cellAlign: 'left'
        });
      }
      window.addEventListener('load', function () { flkty.resize(); });
      if (pendingMediaId) showMedia(pendingMediaId);
    }
    var pendingMediaId = null;
    function showMedia(mediaId) {
      if (!mediaId || !mainSlider) return;
      if (!flkty) { pendingMediaId = mediaId; return; }
      var slides = mainSlider.querySelectorAll('.ed-pdp__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === mediaId) { flkty.select(i); return; }
      }
    }
    if (window.Flickity) initGallery();
    else window.addEventListener('load', initGallery);

    /* ---------- Refs ---------- */
    var styleEls = root.querySelectorAll('[data-ed-size]');
    var jarStep = root.querySelector('[data-ed-jarstep]');
    var jarEls = root.querySelectorAll('[data-ed-jar]');
    var jarText = root.querySelector('[data-ed-jartext]');
    var jarInput = root.querySelector('[data-ed-jartext-input]');
    var jarCount = root.querySelector('[data-ed-jartext-count]');
    var addonBadge = root.querySelector('[data-ed-addon-badge]');
    var catBtns = root.querySelectorAll('[data-ed-cat]');
    var addonEls = root.querySelectorAll('[data-ed-addon]');
    var addonsWrap = root.querySelector('[data-ed-addons]');
    var photoWrap = root.querySelector('[data-ed-photo]');
    var totalEl = root.querySelector('[data-ed-total]');
    var summaryEl = root.querySelector('[data-ed-summary]');
    var priceEl = root.querySelector('[data-ed-pdp-price]');
    var atc = root.querySelector('[data-ed-atc]');

    /* ---------- Step 1: style ---------- */
    function pickStyle(el) {
      state.styleId = el.getAttribute('data-variant-id');
      state.stylePrice = parseInt(el.getAttribute('data-price'), 10) || 0;
      state.styleLabel = el.getAttribute('data-label') || '';
      state.noJar = el.getAttribute('data-nojar') === 'true';
      each(styleEls, function (x) { x.classList.toggle('is-active', x === el); });

      if (jarStep) jarStep.hidden = state.noJar;
      if (addonBadge) addonBadge.textContent = (jarStep && !state.noJar) ? '3' : '2';

      showMedia(el.getAttribute('data-media-id'));
      render();
    }
    each(styleEls, function (el) {
      el.addEventListener('click', function () { if (!el.disabled) pickStyle(el); });
    });

    /* ---------- Step 2: jar message ---------- */
    function pickJar(el, focus) {
      each(jarEls, function (x) { x.classList.toggle('is-active', x === el); });
      state.jarId = el.getAttribute('data-variant-id') || null;
      state.jarPrice = parseInt(el.getAttribute('data-price'), 10) || 0;
      state.jarLabel = el.getAttribute('data-label') || '';
      state.jarPersonalise = el.getAttribute('data-personalise') === 'true';
      if (jarText) jarText.hidden = !state.jarPersonalise;
      if (state.jarPersonalise && focus && jarInput) jarInput.focus();
      render();
    }
    each(jarEls, function (el) {
      el.addEventListener('click', function () { pickJar(el, true); });
    });
    if (jarInput) {
      jarInput.addEventListener('input', function () {
        state.jarText = jarInput.value.slice(0, 20);
        if (jarCount) jarCount.textContent = String(20 - state.jarText.length);
      });
    }

    /* ---------- Step 3: add-ons ---------- */
    function applyCat(cat) {
      each(addonEls, function (a) {
        a.style.display = (cat === 'all' || a.getAttribute('data-cat') === cat) ? '' : 'none';
      });
    }
    each(catBtns, function (b) {
      b.addEventListener('click', function () {
        each(catBtns, function (x) { x.classList.toggle('is-active', x === b); });
        applyCat(b.getAttribute('data-ed-cat'));
      });
    });
    var activeCat = root.querySelector('[data-ed-cat].is-active');
    if (activeCat) {
      var initCat = activeCat.getAttribute('data-ed-cat');
      applyCat(initCat);
      var anyVisible = Array.prototype.some.call(addonEls, function (a) { return a.style.display !== 'none'; });
      if (!anyVisible && initCat !== 'all') {
        each(catBtns, function (x) { x.classList.toggle('is-active', x.getAttribute('data-ed-cat') === 'all'); });
        applyCat('all');
      }
    }

    function updatePhotoReveal() {
      if (!photoWrap) return;
      state.photoAddonId = null;
      each(addonEls, function (a) {
        var id = a.getAttribute('data-variant-id');
        if (a.getAttribute('data-photo-upload') === 'true' && state.addons[id] != null) state.photoAddonId = id;
      });
      var on = !!state.photoAddonId;
      photoWrap.hidden = !on;
      if (!on) {
        photoWrap.removeAttribute('data-photo-url');
        var prev = photoWrap.querySelector('[data-ed-photo-preview]');
        if (prev) prev.innerHTML = '';
      }
    }
    each(addonEls, function (a) {
      var btn = a.querySelector('[data-ed-addon-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = a.getAttribute('data-variant-id');
        if (state.addons[id] != null) {
          delete state.addons[id];
          a.classList.remove('is-added');
        } else {
          state.addons[id] = parseInt(a.getAttribute('data-price'), 10) || 0;
          a.classList.add('is-added');
        }
        render();
        updatePhotoReveal();
      });
    });
    updatePhotoReveal();

    // Order add-ons by best-selling
    var bsUrl = addonsWrap && addonsWrap.getAttribute('data-bestselling-url');
    if (bsUrl) {
      fetch(bsUrl).then(function (r) { return r.json(); }).then(function (order) {
        if (!Array.isArray(order) || !order.length) return;
        var rank = {};
        order.forEach(function (h, i) { rank[h] = i; });
        var cards = Array.prototype.slice.call(addonsWrap.querySelectorAll('[data-ed-addon]'));
        cards.sort(function (a, b) {
          var ra = rank[a.getAttribute('data-handle')]; if (ra == null) ra = 9999;
          var rb = rank[b.getAttribute('data-handle')]; if (rb == null) rb = 9999;
          return ra - rb;
        });
        cards.forEach(function (c) { addonsWrap.appendChild(c); });
      }).catch(function () {});
    }

    /* ---------- Totals and summary ---------- */
    function jarActive() { return !state.noJar && !!state.jarId; }

    function render() {
      var total = state.stylePrice + (jarActive() ? state.jarPrice : 0);
      var addonCount = 0;
      Object.keys(state.addons).forEach(function (id) { total += state.addons[id]; addonCount++; });
      if (totalEl) totalEl.textContent = money(total);
      if (priceEl) priceEl.textContent = money(state.stylePrice);

      var bits = ['1 ' + state.styleLabel];
      if (jarActive()) bits.push(state.jarPersonalise ? 'personalised' : state.jarLabel);
      if (addonCount) bits.push(addonCount + ' add-on' + (addonCount > 1 ? 's' : ''));
      if (summaryEl) summaryEl.textContent = bits.join(' · ');
    }

    /* ---------- Add to cart ---------- */
    if (atc) {
      atc.addEventListener('click', function () {
        if (!state.styleId) return;
        var items = [{ id: Number(state.styleId), quantity: 1 }];

        if (jarActive()) {
          var jarLine = { id: Number(state.jarId), quantity: 1 };
          if (state.jarPersonalise) {
            if (!state.jarText.trim()) {
              alert('Please add the name or message for the jar.');
              if (jarInput) jarInput.focus();
              return;
            }
            jarLine.properties = { 'Jar message': state.jarText };
          }
          items.push(jarLine);
        }

        var photoUrl = photoWrap && photoWrap.getAttribute('data-photo-url');
        if (state.photoAddonId && !photoUrl) {
          alert('Please upload your photo for the Personalised Photo add-on before adding to cart.');
          var pb = root.querySelector('[data-ed-photo-btn]');
          if (pb) pb.scrollIntoView({ block: 'center' });
          return;
        }

        Object.keys(state.addons).forEach(function (id) {
          var item = { id: Number(id), quantity: 1 };
          if (state.photoAddonId && id === state.photoAddonId && photoUrl) {
            item.properties = { 'Personalised Polaroid': photoUrl };
          }
          items.push(item);
        });

        atc.disabled = true;
        atc.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          window.location.href = cartUrl;
        }).catch(function (err) {
          atc.disabled = false;
          atc.textContent = 'Add to cart →';
          console.error('[ed-pdx] add to cart failed', err);
          alert((err && err.description) || 'Sorry, something went wrong adding to cart.');
        });
      });
    }

    /* ---------- Initial state ---------- */
    if (jarEls.length) pickJar(root.querySelector('[data-ed-jar].is-active') || jarEls[0], false);
    var initialStyle = root.querySelector('[data-ed-size].is-active') || styleEls[0];
    if (initialStyle) pickStyle(initialStyle);
    else render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();